import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";
import Header from "./components/Header";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import VideoList from "./components/VideoList";
import VimeoCallback from "./components/VimeoCallback";
import theme from "./config/theme";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Verificar si hay una sesión guardada al cargar la aplicación
  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    if (token && savedUser) {
      try {
        setCurrentUser(JSON.parse(savedUser));
        setIsAuthenticated(true);
      } catch (e) {
        // Si el JSON guardado está corrupto, limpiar sesión
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }
  }, []);

  // Función para manejar el inicio de sesión (recibe token y datos de usuario)
  const handleLogin = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setCurrentUser(user);
    setIsAuthenticated(true);
  };

  // Función para manejar el cierre de sesión
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setCurrentUser(null);
    setIsAuthenticated(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <CssBaseline />
        <Router>
          <Box
            sx={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "background.default",
            }}
          >
            <Header />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Routes>
                <Route
                  path="/"
                  element={
                    isAuthenticated ? (
                      <Dashboard onLogout={handleLogout} currentUser={currentUser} />
                    ) : (
                      <Login onLogin={handleLogin} />
                    )
                  }
                />
                <Route path="/videos" element={<VideoList isPublic={true} />} />
                <Route path="/vimeo/callback" element={<VimeoCallback />} />
              </Routes>
            </Box>

            {/* --- Footer --- */}
            <Box
              component="footer"
              sx={{
                py: 2, // Padding vertical
                px: 2, // Padding horizontal
                mt: "auto", // Empuja el footer hacia abajo
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[900]
                    : theme.palette.grey[200], // Un fondo sutil
                borderTop: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Typography variant="body2" color="text.secondary" align="center">
                FTP Design & Develop By STREAMINGHD.cl ❤️ | Todos los derechos
                reservados.
              </Typography>
            </Box>
            {/* --- Fin Footer --- */}
          </Box>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
